/**
 * @desc 平台站点-列表查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformSiteResponseDto>>;
export function request(
  params: API.basics.platformSite.getList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSite/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
